import React from 'react';
import { ReactComponent as DollarIcon } from 'Assets/svg/dollar-icon.svg';
import { ReactComponent as IndustryIcon } from 'Assets/svg/industry-icon.svg';
import { ReactComponent as AccountOutLine } from 'Assets/svg/account-outline.svg';
import './styles.scss';

const ContactIndustry = ({
  industry,
  employeeCount,
  revenue,
  showNA = true,
}) => {
  return (
    <div className="industry-wrapper">
      {industry && (
        <div className="info-wrap">
          <div className="info-icon">
            <IndustryIcon />
            <span className="tooltip">Industry</span>
          </div>
          <span className="show-elipsis" title={industry}>
            {industry}
          </span>
        </div>
      )}
      <div className="industry-content-info">
        {employeeCount && (
          <span className="info-wrap">
            <div className="info-icon">
              <AccountOutLine className="account-icon" />
              <span className="tooltip">Employee Count</span>
            </div>
            <span>{employeeCount}</span>
          </span>
        )}
        {employeeCount && revenue && '|'}
        {revenue && (
          <span className="info-wrap">
            <div className="info-icon">
              <DollarIcon />
              <span className="tooltip">Revenue</span>
            </div>
            <span>{revenue}</span>
          </span>
        )}
      </div>
      {showNA && !employeeCount && !revenue && !industry && (
        <span className="not-available-text">- NA -</span>
      )}
    </div>
  );
};
export default ContactIndustry;
